import {AfterContentInit, AfterViewInit, Component, Injector, OnInit} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {AddOrUpdateUserOptions} from "./options/add-or-update-user.options";
import {BaseComponent} from "../../../base.component";
import {ListResponse} from "../../../../network/service/list.response";
import {SnackBarUtil} from "../../../../util/snack.bar.util";
import {DataResponse} from "../../../../network/service/data.response";
import {AttributeSelectorOptions} from "../attribute-selector/options/attribute-selector.options";
import {AttributeSelectorComponent} from "../attribute-selector/attribute-selector.component";
import {RequestType} from "../../../../enums/request.type";

@Component({
  selector: 'app-add-or-update-user',
  standalone: false,
  templateUrl: './add-or-update-user.component.html',
  styleUrls: ['./add-or-update-user.component.scss']
})
export class AddOrUpdateUserComponent extends BaseComponent implements OnInit, AfterViewInit, AfterContentInit {
  addOrUpdateUserOptions = new AddOrUpdateUserOptions();
  status = 'Enable';
  firstName?: any;
  lastName?: any;
  nationalCode?: any;
  mobileNumber?: any;
  email?: any;
  selectedAttributes?: any;
  businessId?: any;
  isActive?: any;
  username?: any;
  roleList: any;
  showRoles?: boolean;
  userRoles: any = [];
  userId?: string;
  userType?: string;

  constructor(injector: Injector, private matDialogRef: MatDialogRef<AddOrUpdateUserComponent>) {
    super(injector);
  }

  override ngOnInit() {
    this.userId = this.addOrUpdateUserOptions.user.UserId;
    this.firstName = this.addOrUpdateUserOptions.user.FirstName;
    this.lastName = this.addOrUpdateUserOptions.user.LastName;
    this.nationalCode = this.addOrUpdateUserOptions.user.NationalCode;
    this.mobileNumber = this.addOrUpdateUserOptions.user.MobileNumber;
    this.email = this.addOrUpdateUserOptions.user.Email;
    this.isActive = this.addOrUpdateUserOptions.user.IsActive;
    this.selectedAttributes = this.addOrUpdateUserOptions.user.UserExtraAttributes;
    this.businessId = this.addOrUpdateUserOptions.user.BusinessId;
    this.showRoles = this.addOrUpdateUserOptions.showRole;
    this.userType = this.addOrUpdateUserOptions.userType;
    if (this.addOrUpdateUserOptions.user.UserId) {
      this.serviceApi.getUsernameOfUser(this.addOrUpdateUserOptions.user.AccessKey).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          this.username = res.data.Username;
        }
      });
    }
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getRoles(0, 0, 'Business', RequestType.ALL, {
      Order: this.tableProperties.order ?? {
        Field: 'ModifyDate',
        Type: 'DESC'
      }
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.roleList = res.data;
        this.onServiceCall();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  onServiceCall() {
    this.serviceApi.getUserRoles(this.tableProperties.offset, this.tableProperties.limit, undefined, RequestType.ALL, {
      Filter: {
        Type: 'AND',
        Values: [
          {
            Field: 'UserId',
            Value: this.addOrUpdateUserOptions.user.UserId
          }, {
            Field: 'BusinessId',
            Value: this.businessId
          }
        ]
      },
      Order: this.tableProperties.order ?? {
        Field: 'ModifyDate',
        Type: 'DESC'
      }
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.userRoles = res.data;
        this.setListeners();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  override setListeners() {
    super.setListeners();
    for (let i = 0; i < this.roleList.length; i++) {
      this.roleList[i].IsSelected = false;
      for (let j = 0; j < this.userRoles.length; j++) {
        if (this.roleList[i].RoleId === this.userRoles[j].RoleId) {
          this.roleList[i].UserRoleId = this.userRoles[j].UserRoleId;
          this.roleList[i].IsSelected = true;
        }
      }
    }
  }

  noAction() {
    this.matDialogRef.close();
  }

  onNationalCodeInput(event: any) {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/[^0-9]/g, '');
    if (value.length <= 10) {
      this.nationalCode = value;
    } else {
      input.value = value.slice(0, 10);
      this.nationalCode = input.value;
    }
  }

  onMobileNumberInput(event: any) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/[^0-9]/g, '');
    if (value.length <= 12) {
      this.mobileNumber = value;
    } else {
      input.value = value.slice(0, 12);
      this.mobileNumber = input.value;
    }
  }

  onSubmitClicked() {
    if ((this.userType === 'STAFF' && this.isRequiredFieldsFilled(this.firstName, this.lastName, this.mobileNumber, this.nationalCode)) || (this.userType === 'CLIENT' && this.isRequiredFieldsFilled(this.firstName, this.lastName, this.mobileNumber))) {
      (this.addOrUpdateUserOptions.user.UserId !== undefined ? this.serviceApi.updateUsers(this.addOrUpdateUserOptions.user.UserId, {
        FirstName: this.firstName,
        LastName: this.lastName,
        MobileNumber: this.mobileNumber,
        Email: this.email,
        NationalCode: this.nationalCode,
        Password: this.mobileNumber,
        ExtraAttributeIds: (this.selectedAttributes ?? []).map((attribute: any) => {
          return attribute.AttributeId;
        }),
        IsActive: this.isActive ? this.isActive : false,
        UserType: this.userType,
        BusinessId: this.businessId
      }) : this.serviceApi.createUsers({
        FirstName: this.firstName,
        LastName: this.lastName,
        MobileNumber: this.mobileNumber,
        Email: this.email,
        NationalCode: this.nationalCode,
        Username: this.username,
        Password: this.mobileNumber,
        ExtraAttributeIds: (this.selectedAttributes ?? []).map((attribute: any) => {
          return attribute.AttributeId;
        }),
        UserType: this.userType,
        IsActive: this.isActive ? this.isActive : false,
        BusinessId: this.businessId
      })).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          if (this.userType === 'STAFF') {
            this.addOrUpdateUserOptions.onInsertOrUpdateFinished();
            this.showRoles = true;
            this.addOrUpdateUserOptions.user = res.data.dataValues;
            this.userId = this.addOrUpdateUserOptions.user.UserId;
            this.businessId = this.addOrUpdateUserOptions.user.BusinessId;
            this.roleList = [];
            this.loadOnline();
          } else {
            this.addOrUpdateUserOptions.onInsertOrUpdateFinished(res.data.dataValues);
            this.noAction();
          }
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    }
  }

  onAssignRoleToStaff(role: any) {
    if (role.IsSelected === true) {
      this.serviceApi.deleteUserRoles(role.UserRoleId).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          role.IsSelected = false;
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    }
    if (role.IsSelected === false) {
      this.serviceApi.createUserRoles({
        RoleId: role.RoleId,
        UserId: this.userId,
        BusinessId: this.businessId
      }).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          role.IsSelected = true;
          role.UserRoleId = res.data!.dataValues.UserRoleId;
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    }
  }

  onConsumerAttributeClicked() {
    let attributeSelectorOptions = new AttributeSelectorOptions();
    attributeSelectorOptions.attributeList = this.selectedAttributes;
    attributeSelectorOptions.onAttributeSelected = (attributes: any[]) => {
      this.selectedAttributes = attributes;
    };
    let attributeSelectorComponent = this.matDialog.open(AttributeSelectorComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    attributeSelectorComponent.componentInstance.attributeSelectorOptions = attributeSelectorOptions;
  }
}
